__turbopack_context__.v({
  "container": "SocialProofRolling-module-scss-module__EVKzKq__container",
  "item": "SocialProofRolling-module-scss-module__EVKzKq__item",
  "itemExit": "SocialProofRolling-module-scss-module__EVKzKq__itemExit",
  "slideOut": "SocialProofRolling-module-scss-module__EVKzKq__slideOut",
  "slideUp": "SocialProofRolling-module-scss-module__EVKzKq__slideUp",
});
